var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: `examples-in-use theme-${_vm.color.color1} theme2-${_vm.color.color2}`,
    },
    [
      _c("div", { staticClass: "row align-bottom" }, [
        _c("div", [
          _c("h3", [_vm._v("Icons in Action")]),
          _vm._v(" "),
          _c("p", { staticClass: "line-length-xl" }, [
            _vm._v(
              "\n        Ever wonder what “" +
                _vm._s(_vm.icon.name) +
                "” might look like in the mix? Well, you're in luck! We've cooked up some examples of how you could use\n        the “" +
                _vm._s(_vm.icon.name) +
                "” icon in your projects, whether they're apps, interfaces, or print designs.\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row roomy padding-y-2xl align-stretch" }, [
        _c(
          "div",
          { staticClass: "column-12 laptop:column-4 margin-bottom-xl" },
          [
            _c(
              "div",
              {
                staticClass: "card padding-top-0",
                staticStyle: {
                  "--card-background": "var(--example-color)",
                  height: "100%",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "example-mobileapp",
                    staticStyle: {
                      margin: "0 auto",
                      "background-color": "var(--example-color-alt)",
                      "border-radius": "0 0 1.5em 1.5em",
                    },
                  },
                  [
                    _c("h4", { staticClass: "sr-only" }, [
                      _vm._v("An example of a mobile app using icons"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "var(--spacing-md)",
                          color: "var(--example-color)",
                        },
                      },
                      [
                        _c("i", {
                          class: [`fas fa-spinner-third fa-fw fa-2x fa-spin`],
                          staticStyle: { "--fa-animation-duration": "3s" },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "size-lg strong display-block margin-top-xs",
                          },
                          [_vm._v("Loading...")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "display-flex flex-content-around",
                        staticStyle: {
                          "background-color": "var(--fa-navy)",
                          padding: "var(--spacing-sm) var(--spacing-xs)",
                          "border-radius": "0 0 1.5em 1.5em",
                          "--button-border-radius": "var(--border-radius-lg)",
                          "--button-padding": "var(--button-padding-vertical)",
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "flat",
                            staticStyle: {
                              "--button-hover-background":
                                "var(--example-color-alt)",
                              "--button-color": "var(--example-color-alt)",
                              "--button-background": "var(--white)",
                              "--button-margin-bottom": "0",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v6.solid.faPaperPlane,
                                size: "xl",
                                "fixed-width": "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("example button"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "flat",
                            staticStyle: {
                              "--button-hover-background":
                                "var(--example-color-alt)",
                              "--button-color": "var(--white)",
                              "--button-background": "var(--example-color-alt)",
                              "--button-margin-bottom": "0",
                            },
                          },
                          [
                            _c("i", {
                              class: [
                                `${_vm.getIconStyle(_vm.icon.style)} fa-${
                                  _vm.icon.name
                                } fa-fw fa-xl`,
                              ],
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("example button"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "flat",
                            staticStyle: {
                              "--button-hover-background":
                                "var(--example-color-alt)",
                              "--button-color": "var(--example-color-alt)",
                              "--button-background": "var(--white)",
                              "--button-margin-bottom": "0",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v6.solid.faPhone,
                                size: "xl",
                                "fixed-width": "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("example button"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "flat",
                            staticStyle: {
                              "--button-hover-background":
                                "var(--example-color-alt)",
                              "--button-color": "var(--example-color-alt)",
                              "--button-background": "var(--white)",
                              "--button-margin-bottom": "0",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v6.solid.faComment,
                                size: "xl",
                                "fixed-width": "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("example button"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "flat display-block laptop:display-none",
                            staticStyle: {
                              "--button-hover-background":
                                "var(--example-color-alt)",
                              "--button-color": "var(--example-color-alt)",
                              "--button-background": "var(--white)",
                              "--button-margin-bottom": "0",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v6.solid.faBullhorn,
                                size: "xl",
                                "fixed-width": "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("example button"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "flat display-block laptop:display-none",
                            staticStyle: {
                              "--button-hover-background":
                                "var(--example-color-alt)",
                              "--button-color": "var(--example-color-alt)",
                              "--button-background": "var(--white)",
                              "--button-margin-bottom": "0",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v6.solid.faMicrophone,
                                size: "xl",
                                "fixed-width": "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("example button"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "flat display-block laptop:display-none",
                            staticStyle: {
                              "--button-hover-background":
                                "var(--example-color-alt)",
                              "--button-color": "var(--example-color-alt)",
                              "--button-background": "var(--white)",
                              "--button-margin-bottom": "0",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v6.solid.faCameraRetro,
                                size: "xl",
                                "fixed-width": "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("example button"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "column-12 tablet:column-6 laptop:column-4 margin-bottom-xl",
          },
          [
            _c(
              "div",
              {
                staticClass: "card display-flex align-center",
                staticStyle: {
                  "flex-direction": "column",
                  "--card-background": "var(--example-color-alt)",
                  height: "100%",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "example-sign display-flex margin-bottom-lg",
                    staticStyle: {
                      "z-index": "2",
                      "border-radius": "var(--border-radius-md)",
                      "background-color": "var(--white)",
                    },
                  },
                  [
                    _c("h4", { staticClass: "sr-only" }, [
                      _vm._v("An example of a signs with icons"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-left text-truncate padding-x-md padding-y-lg laptop:padding-x-lg",
                        staticStyle: {
                          "flex-grow": "3",
                          color: "var(--example-color-alt)",
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v6.solid.faBus,
                            size: "2xl",
                            "fixed-width": "",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "margin-left-md",
                            staticStyle: { color: "var(--fa-navy)" },
                          },
                          [_vm._v("\n              Bus\n            ")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "var(--spacing-lg)",
                          "background-color": "var(--fa-navy)",
                          color: "var(--white)",
                          "border-radius":
                            "0 var(--border-radius-md) var(--border-radius-md) 0",
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v6.solid.faArrowUp,
                            size: "xl",
                            "fixed-width": "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "sign display-flex margin-bottom-lg",
                    staticStyle: {
                      "z-index": "2",
                      "border-radius": "var(--border-radius-md)",
                      "background-color": "var(--white)",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-left text-truncate padding-x-md padding-y-lg laptop:padding-x-lg",
                        staticStyle: {
                          "flex-grow": "3",
                          color: "var(--example-color-alt)",
                        },
                      },
                      [
                        _c("i", {
                          class: [
                            `${_vm.getIconStyle("solid")} fa-fw fa-2xl fa-${
                              _vm.icon.name
                            }`,
                          ],
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "margin-left-md text-capitalize",
                            staticStyle: { color: "var(--fa-navy)" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.icon.name) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "var(--spacing-lg)",
                          "background-color": "var(--fa-navy)",
                          color: "var(--white)",
                          "border-radius":
                            "0 var(--border-radius-md) var(--border-radius-md) 0",
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v6.solid.faArrowRight,
                            size: "xl",
                            "fixed-width": "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "z-index": "1",
                      position: "absolute",
                      top: "0",
                      left: "15%",
                      width: "15px",
                      height: "65%",
                      "background-color": "var(--example-color)",
                    },
                  },
                  [_vm._v(" ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "z-index": "1",
                      position: "absolute",
                      top: "0",
                      right: "15%",
                      width: "15px",
                      height: "65%",
                      "background-color": "var(--example-color)",
                    },
                  },
                  [_vm._v(" ")]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "column-12 tablet:column-6 laptop:column-4 margin-bottom-xl",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "card display-flex flex-column flex-content-end text-left padding-bottom-0",
                staticStyle: {
                  "--card-background": "var(--example-color)",
                  height: "100%",
                },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "background-color": "var(--white)" } },
                  [
                    _c("ul", { staticClass: "fa-ul" }, [
                      _c(
                        "li",
                        {
                          staticStyle: {
                            padding: "var(--spacing-sm)",
                            "border-bottom": "1px solid var(--fa-gravy)",
                            color: "var(--example-color-alt)",
                          },
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-left text-truncate padding-y-4xs",
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: {
                                  icon: _vm.todoListIcons.icon1,
                                  size: "xl",
                                  "fixed-width": "",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "text-truncate margin-left-md" },
                                [_vm._v(_vm._s(_vm.theme.icon1.label))]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticStyle: {
                            padding: "var(--spacing-sm)",
                            "border-bottom": "1px solid var(--fa-gravy)",
                          },
                        },
                        [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-left text-truncate padding-y-4xs",
                            },
                            [
                              _c("i", {
                                class: [
                                  `${_vm.getIconStyle(
                                    _vm.lightestStyle
                                  )} fa-fw fa-xl fa-${_vm.icon.name}`,
                                ],
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-truncate text-capitalize margin-left-md",
                                  staticStyle: { color: "var(--fa-navy)" },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.icon.name) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticStyle: { padding: "var(--spacing-sm)" } },
                        [
                          _vm._m(3),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-left text-truncate padding-y-4xs",
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: {
                                  icon: _vm.todoListIcons.icon2,
                                  size: "xl",
                                  "fixed-width": "",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "margin-left-md",
                                  staticStyle: { color: "var(--fa-navy)" },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.theme.icon2.label) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column-12 laptop:column-6 margin-bottom-xl" },
          [
            _c(
              "div",
              {
                staticClass:
                  "card display-flex flex-column flex-content-end text-left padding-bottom-0",
                staticStyle: {
                  "--card-background": "var(--example-color)",
                  height: "100%",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "examples-website display-flex padding-xs align-middle",
                    staticStyle: {
                      color: "var(--example-color)",
                      "background-color": "var(--fa-navy)",
                      "border-radius":
                        "var(--border-radius-md) var(--border-radius-md) 0 0",
                    },
                  },
                  [
                    _c("h4", { staticClass: "sr-only" }, [
                      _vm._v("An example of a website with icons"),
                    ]),
                    _vm._v(" "),
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-center padding-x-4xl padding-y-4xs margin-x-2xl",
                        staticStyle: {
                          "flex-grow": "2",
                          opacity: "0.7",
                          "background-color": "var(--fa-dk-navy)",
                          "border-radius": "var(--border-radius-lg)",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.icon.name) +
                            "-opedia\n          "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "display-flex",
                    staticStyle: {
                      "background-color": "var(--example-color-alt)",
                      color: "var(--example-color)",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "padding-x-sm padding-y-md text-center",
                        staticStyle: {
                          "border-right": "2px solid var(--example-color)",
                          "flex-grow": "1",
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "margin-right-4xs",
                          attrs: {
                            icon: _vm.$v6.solid.faHouseChimney,
                            size: "lg",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Home")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "padding-x-sm padding-y-md text-center",
                        staticStyle: {
                          "border-right": "2px solid var(--example-color)",
                          color: "var(--white)",
                          "flex-grow": "1",
                        },
                      },
                      [
                        _c("i", {
                          class: [
                            `${_vm.getIconStyle("solid")} fa-lg fa-${
                              _vm.icon.name
                            } margin-right-4xs`,
                          ],
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("About")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "padding-x-sm padding-y-md text-center",
                        staticStyle: {
                          "border-right": "2px solid var(--example-color)",
                          "flex-grow": "1",
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "margin-right-4xs",
                          attrs: {
                            icon: _vm.$v6.solid.faDollarCircle,
                            size: "lg",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Pricing")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "padding-x-sm padding-y-md text-center",
                        staticStyle: { "flex-grow": "1" },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "margin-right-4xs",
                          attrs: {
                            icon: _vm.$v6.solid.faUserCircle,
                            size: "lg",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Account")]),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "display-flex flex-items-center padding-x-2xl padding-y-lg",
                    staticStyle: {
                      "background-color": "var(--white)",
                      color: "var(--fa-gravy)",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "fa-stack fa-2x",
                        staticStyle: { "flex-shrink": "0" },
                      },
                      [
                        _c("i", { staticClass: "far fa-circle fa-stack-2x" }),
                        _vm._v(" "),
                        _c("i", {
                          class: [
                            `${_vm.getIconStyle("solid")} fa-${
                              _vm.icon.name
                            } fa-stack-1x`,
                          ],
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "margin-left-md size-lg text-truncate",
                        staticStyle: { "line-height": "1.2" },
                      },
                      [
                        _vm._v(
                          "\n            We're your place for all things\n            "
                        ),
                        _c("span", { staticClass: "laptop:display-block" }, [
                          _vm._v(_vm._s(_vm.icon.name) + "."),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "column-12 tablet:column-6 laptop:column-6 margin-bottom-xl",
          },
          [
            _c(
              "div",
              {
                staticClass: "card padding-x-3xl laptop:padding-x-6xl",
                staticStyle: {
                  "--card-background": "var(--fa-navy)",
                  "--card-color": "var(--white)",
                  height: "100%",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "examples-transitline display-flex flex-content-center flex-column",
                    staticStyle: { height: "100%" },
                  },
                  [
                    _c("h4", { staticClass: "sr-only" }, [
                      _vm._v("An example of a transit line using icons"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "display-flex flex-content-between" },
                      [
                        _c("font-awesome-icon", {
                          staticStyle: { color: "var(--example-color)" },
                          attrs: {
                            icon: _vm.$v6.solid.faTrees,
                            size: "2x",
                            "fixed-width": "",
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          class: [
                            `${_vm.getIconStyle("solid")} fa-${
                              _vm.icon.name
                            } fa-fw fa-2x fa-beat-fade`,
                          ],
                          staticStyle: {
                            color: "var(--example-color)",
                            "--fa-animation-duration": "2s",
                          },
                        }),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticStyle: { color: "var(--fa-gravy)" },
                          attrs: {
                            icon: _vm.$v6.light.faHouse,
                            size: "2x",
                            "fixed-width": "",
                          },
                        }),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticStyle: { color: "var(--fa-gravy)" },
                          attrs: {
                            icon: _vm.$v6.light.faBuildings,
                            size: "2x",
                            "fixed-width": "",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(5),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "column-12 tablet:column-6 laptop:column-4 margin-bottom-xl",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "card display-flex flex-content-center flex-items-center",
                staticStyle: {
                  color: "var(--white)",
                  height: "100%",
                  background:
                    "center / cover var(--fa-navy) url('https://img.fortawesome.com/1ce05b4b/background-bricks2.png') repeat",
                },
              },
              [
                _c("i", {
                  class: [
                    `${_vm.getIconStyle("solid")} fa-${
                      _vm.icon.name
                    } fa-fw fa-6x`,
                  ],
                }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "column-12 tablet:column-6 laptop:column-4 margin-bottom-xl",
          },
          [
            _c(
              "div",
              {
                staticClass: "card",
                staticStyle: {
                  "--card-background": "var(--example-color)",
                  height: "100%",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "examples-buttons display-flex flex-column flex-content-center",
                    staticStyle: { height: "100%" },
                  },
                  [
                    _c("h4", { staticClass: "sr-only" }, [
                      _vm._v("An example of a buttons with icons"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "block",
                        staticStyle: {
                          "--button-active-background":
                            "var(--example-color-alt)",
                          "--button-hover-background": "var(--example-color)",
                        },
                      },
                      [
                        _c("i", {
                          class: [
                            `${_vm.getIconStyle("light")} fa-${
                              _vm.icon.name
                            } fa-fw fa-xl margin-right-md`,
                          ],
                          staticStyle: { color: "var(--example-color-alt)" },
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.theme.button.default) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "block active",
                        staticStyle: {
                          "--button-active-background":
                            "var(--example-color-alt)",
                          "--button-hover-background": "var(--example-color)",
                        },
                      },
                      [
                        _c("i", {
                          class: [
                            `${_vm.getIconStyle("light")} fa-${
                              _vm.icon.name
                            } fa-fw fa-xl margin-right-md fa-spin`,
                          ],
                          staticStyle: {
                            color: "var(--white)",
                            "--fa-animation-duration": "2s",
                          },
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.theme.button.active) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "column-12 tablet:column-6 laptop:column-4 margin-bottom-xl",
          },
          [
            _c(
              "div",
              {
                staticClass: "card",
                staticStyle: {
                  "--card-background": "var(--fa-navy)",
                  height: "100%",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "examples-notification tablet:size-sm laptop:size-md display-flex flex-items-center flex-content-center",
                    staticStyle: { height: "100%" },
                  },
                  [
                    _c("h4", { staticClass: "sr-only" }, [
                      _vm._v("An example of a notification with icons"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "card display-flex flex-row flex-items-center padding-0 size-md tablet:size-sm laptop:size-xs",
                        staticStyle: {
                          "--card-background": "var(--white)",
                          "--card-margin-bottom": "0",
                          "align-items": "stretch",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "display-flex flex-items-center padding-xl",
                            staticStyle: { "flex-grow": "0" },
                          },
                          [
                            _c("i", {
                              class: [
                                `${_vm.getIconStyle(_vm.lightestStyle)} fa-${
                                  _vm.icon.name
                                } fa-fw fa-3x`,
                              ],
                              staticStyle: { color: "var(--example-color)" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "display-flex flex-items-center padding-xl text-left size-lg",
                            staticStyle: {
                              "background-color": "var(--example-color)",
                              "border-radius":
                                "0 var(--border-radius-sm) var(--border-radius-sm) 0",
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.theme.alert))])]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column-12 laptop:column-6 margin-bottom-xl" },
          [
            _c(
              "div",
              {
                staticClass: "card padding-0",
                staticStyle: {
                  "--card-background": "var(--example-color)",
                  height: "100%",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "examples-sizing display-flex flex-column",
                    staticStyle: { height: "100%" },
                  },
                  [
                    _c("h4", { staticClass: "sr-only" }, [
                      _vm._v("An example of a icons sized and stacked"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "display-flex flex-items-center flex-content-between padding-y-lg padding-right-5xl padding-left-4xl laptop:padding-right-4xl laptop:padding-left-4xl",
                        staticStyle: {
                          color: "var(--example-color)",
                          "background-color": "var(--fa-navy)",
                          "border-radius":
                            "var(--border-radius-md) var(--border-radius-md) 0 0",
                          "flex-grow": "1",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "fa-stack fa-4x",
                            staticStyle: { "flex-shrink": "0" },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-circle fa-stack-2x",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                `${_vm.getIconStyle(_vm.lightestStyle)} fa-${
                                  _vm.icon.name
                                } fa-stack-1x fa-inverse`,
                              ],
                              staticStyle: { "--fa-inverse": "var(--fa-navy)" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "fa-stack fa-3x",
                            staticStyle: { "flex-shrink": "0" },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-circle fa-stack-2x",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                `${_vm.getIconStyle("light")} fa-${
                                  _vm.icon.name
                                } fa-stack-1x fa-inverse`,
                              ],
                              staticStyle: { "--fa-inverse": "var(--fa-navy)" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "fa-stack fa-2x",
                            staticStyle: { "flex-shrink": "0" },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-circle fa-stack-2x",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                `${_vm.getIconStyle("regular")} fa-${
                                  _vm.icon.name
                                } fa-stack-1x fa-inverse`,
                              ],
                              staticStyle: { "--fa-inverse": "var(--fa-navy)" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "fa-stack fa-1x",
                            staticStyle: { "flex-shrink": "0" },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-circle fa-stack-2x",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                `${_vm.getIconStyle("solid")} fa-${
                                  _vm.icon.name
                                } fa-stack-1x fa-inverse`,
                              ],
                              staticStyle: { "--fa-inverse": "var(--fa-navy)" },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "display-flex flex-items-center flex-content-between padding-y-lg padding-left-5xl padding-right-4xl laptop:padding-left-4xl laptop:padding-right-4xl",
                        staticStyle: { "flex-grow": "1" },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "fa-stack fa-1x",
                            staticStyle: { "flex-shrink": "0" },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-square fa-stack-2x",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                `${_vm.getIconStyle("solid")} fa-${
                                  _vm.icon.name
                                } fa-stack-1x fa-inverse`,
                              ],
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "fa-stack fa-2x",
                            staticStyle: { "flex-shrink": "0" },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-square fa-stack-2x",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                `${_vm.getIconStyle("regular")} fa-${
                                  _vm.icon.name
                                } fa-stack-1x fa-inverse`,
                              ],
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "fa-stack fa-3x",
                            staticStyle: { "flex-shrink": "0" },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-square fa-stack-2x",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                `${_vm.getIconStyle("light")} fa-${
                                  _vm.icon.name
                                } fa-stack-1x fa-inverse`,
                              ],
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "fa-stack fa-4x",
                            staticStyle: { "flex-shrink": "0" },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-square fa-stack-2x",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                `${_vm.getIconStyle(_vm.lightestStyle)} fa-${
                                  _vm.icon.name
                                } fa-stack-1x fa-inverse`,
                              ],
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column-12 laptop:column-6 margin-bottom-xl" },
          [
            _c(
              "div",
              {
                staticClass: "card padding-x-3xl laptop:padding-x-6xl",
                staticStyle: {
                  "--card-color": "var(--fa-navy)",
                  "--card-background": "var(--example-color)",
                  height: "100%",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "examples-sizing display-flex flex-content-center flex-column",
                    staticStyle: { height: "100%" },
                  },
                  [
                    _c("h4", { staticClass: "sr-only" }, [
                      _vm._v("An example of pull quote with an icon"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "size-lg laptop:size-xl text-left" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "fa-stack fa-2x fa-pull-left",
                            staticStyle: { width: "2em" },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-square fa-stack-2x",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                `${_vm.getIconStyle("solid")} fa-${
                                  _vm.icon.name
                                } fa-stack-1x fa-inverse`,
                              ],
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", [_vm._v("“" + _vm._s(_vm.theme.quote) + "”")]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "example-todos text-capitalize text-center padding-xs",
        staticStyle: {
          color: "var(--example-color)",
          "background-color": "var(--fa-navy)",
          "border-radius":
            "var(--border-radius-md) var(--border-radius-md) 0 0",
        },
      },
      [
        _c("h4", { staticClass: "sr-only" }, [
          _vm._v("An example of a to-do list with icons"),
        ]),
        _vm._v("\n          Future to-do list\n        "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-li padding-y-4xs" }, [
      _c("i", { staticClass: "far fa-check-square" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-li padding-y-4xs" }, [
      _c("i", {
        staticClass: "far fa-square",
        staticStyle: { color: "var(--example-color-alt)" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-li padding-y-4xs" }, [
      _c("i", {
        staticClass: "far fa-square",
        staticStyle: { color: "var(--example-color-alt)" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "display-flex align-middle" }, [
      _c(
        "div",
        {
          staticClass: "display-inline-block margin-left-3xs",
          staticStyle: {
            width: "15px",
            height: "15px",
            "background-color": "var(--fa-dk-navy)",
            "border-radius": "var(--border-radius-lg)",
          },
        },
        [_vm._v("\n               \n            ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "display-inline-block margin-left-3xs",
          staticStyle: {
            width: "15px",
            height: "15px",
            "background-color": "var(--fa-dk-navy)",
            "border-radius": "var(--border-radius-lg)",
          },
        },
        [_vm._v("\n               \n            ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "display-inline-block margin-left-3xs",
          staticStyle: {
            width: "15px",
            height: "15px",
            "background-color": "var(--fa-dk-navy)",
            "border-radius": "var(--border-radius-lg)",
          },
        },
        [_vm._v("\n               \n            ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "position-relative display-flex margin-y-3xl margin-x-sm size-xs",
        staticStyle: { height: "1em" },
      },
      [
        _c(
          "div",
          {
            staticClass: "position-absolute z-index-2",
            staticStyle: {
              top: "-0.5em",
              left: "0",
              border: "0.5em solid var(--white)",
              height: "2em",
              width: "2em",
              "border-radius": "var(--border-radius-lg)",
              "background-color": "var(--example-color)",
            },
          },
          [_vm._v("\n               \n            ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "padding-4xs",
            staticStyle: {
              "flex-grow": "2",
              background: "var(--white)",
              "border-radius": "var(--border-radius-lg)",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "border-top": "0.5em solid var(--example-color)",
                  height: "1px",
                },
              },
              [_vm._v(" ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "position-absolute z-index-2",
            staticStyle: {
              top: "-0.5em",
              left: "31%",
              border: "0.5em solid var(--white)",
              height: "2em",
              width: "2em",
              "border-radius": "var(--border-radius-lg)",
              "background-color": "var(--example-color)",
            },
          },
          [_vm._v("\n               \n            ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "padding-4xs",
            staticStyle: {
              "flex-grow": "2",
              background: "var(--white)",
              "border-radius": "var(--border-radius-lg)",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "border-top": "0.5em dotted var(--example-color)",
                  height: "1px",
                },
              },
              [_vm._v(" ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "position-absolute z-index-2",
            staticStyle: {
              top: "-0.5em",
              right: "31%",
              border: "0.5em solid var(--white)",
              height: "2em",
              width: "2em",
              "border-radius": "var(--border-radius-lg)",
              "background-color": "var(--example-color)",
            },
          },
          [_vm._v("\n               \n            ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "padding-4xs",
            staticStyle: {
              "flex-grow": "2",
              background: "var(--white)",
              "border-radius": "var(--border-radius-lg)",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "border-top": "0.5em solid var(--white)",
                  height: "1px",
                },
              },
              [_vm._v(" ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "position-absolute z-index-2",
            staticStyle: {
              top: "-0.5em",
              right: "0",
              border: "0.5em solid var(--white)",
              height: "2em",
              width: "2em",
              "border-radius": "var(--border-radius-lg)",
              "background-color": "var(--example-color)",
            },
          },
          [_vm._v("\n               \n            ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }